'use client'

import React, { createContext, useEffect, useState } from 'react'

import { useTenant } from '@rewardops/auth'

type BEXContextProviderProps = {
  children: React.ReactNode
}

export const BEXContext = createContext(false)

/**
 * This provider will check if the BEX for respective tenant is installed on the browser or not
 * Right now it supports Chrome, Edge and Firefox, support for Safari is limited
 */
export const BEXContextProvider: React.FC<BEXContextProviderProps> = ({
  children,
}: BEXContextProviderProps) => {
  const [isBEXInstalled, setIsBEXInstalled] = useState<boolean>(false)
  const tenant = useTenant()

  const checkROExtensionInstalled = () => {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => resolve(false), 5000)

      function handler(event: any) {
        if (event.data?.type === 'RO_BEX_INSTALLED') {
          clearTimeout(timeout)
          window.removeEventListener('message', handler)
          resolve(event.data.env)
        }
      }

      window.addEventListener('message', handler)
      window.postMessage({ type: 'CHECK_RO_BEX_INSTALLED' }, '*')
    })
  }

  const doesBEXBelongToThisTenant = (tenantId: string): boolean => {
    if (
      tenant?.programConfig?.programName
        ?.toLowerCase()
        ?.includes(tenantId?.toLowerCase())
    ) {
      return true
    }

    if (tenant?.bex?.name?.toLowerCase()?.includes(tenantId?.toLowerCase())) {
      return true
    }

    return false
  }

  useEffect(() => {
    checkROExtensionInstalled().then((response: any) => {
      if (response.tenantId && doesBEXBelongToThisTenant(response?.tenantId)) {
        setIsBEXInstalled(true)
      }
    })
  }, [])

  return (
    <BEXContext.Provider value={isBEXInstalled}>{children}</BEXContext.Provider>
  )
}
